import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import { API_URL } from "./Config";
import CommonDatePicker from "./datepicker/CommonDatePicker";
import { useParams } from "react-router-dom";
import { format, startOfMonth, endOfMonth } from "date-fns";
import config from "./common/Config";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const { prefix, userId } = useParams();

  const today = new Date();
  const [dates, setDates] = useState([startOfMonth(today), endOfMonth(today)]);
  const [selectedRole, setSelectedRole] = useState("");
  const [statisticsData, setStatisticsData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const company_tax_type = localStorage.getItem("company_tax_type");
  const currencySymbol = localStorage.getItem("currencySymbol");

  const handleDateChange = (value) => {
    setDates(value);

    if (value && value[0] && value[1]) {
      const formattedStartDate = format(value[0], 'MM/dd/yyyy');
      const formattedEndDate = format(value[1], 'MM/dd/yyyy');

      const s1 = value[0] ? format(value[0], 'yyyy-MM-dd') : '';
      const e1 = value[1] ? format(value[1], 'yyyy-MM-dd') : '';

      localStorage.setItem('startDate', s1);
      localStorage.setItem('endDate', e1);

      console.log(`Selected date range: ${formattedStartDate} - ${formattedEndDate}`);
      
      fetchDataWithDates(value);
    }
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const fetchDataWithDates = async (dateRange) => {
    localStorage.setItem("accessToken", prefix);
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/react/login";
      return;
    }

    setIsLoading(true);

    const [startDate, endDate] = dateRange;
    const formattedStartDate = startDate ? format(startDate, "MM/dd/yyyy") : "";
    const formattedEndDate = endDate ? format(endDate, "MM/dd/yyyy") : "";
    const reportrange = (formattedStartDate && formattedEndDate) ? `${formattedStartDate} - ${formattedEndDate}` : "";

    const s1 = startDate ? format(startDate, "yyyy-MM-dd") : "";
    const e1 = endDate ? format(endDate, "yyyy-MM-dd") : "";

    localStorage.setItem("startDate", s1);
    localStorage.setItem("endDate", e1);

    const formData = new FormData();
    formData.append("reportrange", reportrange);
    formData.append("role", selectedRole);
    formData.append("prefix", prefix);

    const apiUrl = `${config.API_URL}/get_dashboard_count`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch statistics data");
      }

      const data = await response.json();
      setStatisticsData(data);
    } catch (error) {
      console.error("Error fetching statistics data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    localStorage.setItem("accessToken", prefix);
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/react/login";
      return;
    }

    setIsLoading(true);

    const [startDate, endDate] = dates;
    const formattedStartDate = startDate ? format(startDate, "MM/dd/yyyy") : "";
    const formattedEndDate = endDate ? format(endDate, "MM/dd/yyyy") : "";
    const reportrange = (formattedStartDate && formattedEndDate) ? `${formattedStartDate} - ${formattedEndDate}` : "";

    const s1 = startDate ? format(startDate, "yyyy-MM-dd") : "";
    const e1 = endDate ? format(endDate, "yyyy-MM-dd") : "";

    localStorage.setItem("startDate", s1);
    localStorage.setItem("endDate", e1);

    const formData = new FormData();
    formData.append("reportrange", reportrange);
    formData.append("role", selectedRole);
    formData.append("prefix", prefix);

    const apiUrl = `${config.API_URL}/get_dashboard_count`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch statistics data");
      }

      const data = await response.json();
      setStatisticsData(data);
    } catch (error) {
      console.error("Error fetching statistics data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserData = async () => {
    const formData = new FormData();
    formData.append("id", userId);
    formData.append("prefix", prefix);
    try {
      const response = await axios.post(
        `${config.API_URL}/get_users_details_id`,
        formData,
        {
          headers: {
            authorization: `Bearer ${prefix}`,
          },
        }
      );
      const result = response.data;
      if (result.success == true) {
        localStorage.setItem("site_name", result.data.site_name);
        localStorage.setItem("first_name", result.data.first_name);
        localStorage.setItem("last_name", result.data.last_name);
        localStorage.setItem("isSinglePicking", result.data.isSinglePicking);
        localStorage.setItem("roleID", result.data.group_id);
        localStorage.setItem("shopifyConnectivity", result.data.shopifyConnectivity);
        localStorage.setItem("amazonConnectivity", result.data.amazonConnectivity);
        localStorage.setItem("showEmailTemplate", result.data.showEmailTemplate);
        localStorage.setItem("showContraPrice", result.data.showContraPrice);
        localStorage.setItem("showCessRate", result.data.showCessRate ?? "N");
        localStorage.setItem("grnExpiryDateIsMandatory", result.data.grnExpiryDateIsMandatory ?? "N");

        fetchDataWithDates(dates);
      } else {
        window.location.href = `${config.LOG_OUT}`;
      }
    } catch (error) {
      console.error("Error accepting order:", error);
    }
  };

 

  useEffect(() => {
    (async () => {
      // const ok = await checkIfAlreadyLoggedIn();
      // if (!ok) return;
      if (prefix) {
        localStorage.setItem("accessToken", prefix);
        localStorage.setItem("userId", userId);
        fetchUserData();
      } else {
        window.location.href = `${config.LOG_OUT}`;
      }
    })();
  }, [prefix, userId]);

  const getDisplayDates = () => {
    if (dates && dates[0] && dates[1]) {
      return {
        from: format(dates[0], "dd/MM/yyyy"),
        to: format(dates[1], "dd/MM/yyyy")
      };
    }
    return {
      from: statisticsData ? statisticsData.from_date : "0",
      to: statisticsData ? statisticsData.to_date : "0"
    };
  };

  const displayDates = getDisplayDates();

  return (
    <div>
      <Header />
      <nav className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#">
                <i className="fa fa-home"></i>
              </a>
              <span className="last-crumb">Dashboard</span>
            </div>
          </div>
        </div>
      </nav>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div className="dash-calender-area">
                <div className="row">
                  <div className="col-12 col-lg-7 col-sm-7">
                    <div className="dashform d-flex">
                      <CommonDatePicker
                        value={dates}
                        onChange={handleDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-5 col-sm-5">
                    <div className="dashdate-area">
                      From: {displayDates.from} &nbsp; To: {displayDates.to}
                    </div>
                  </div>
                </div>
              </div>

              {isLoading ? (
                <div className="loading-container" style={{ textAlign: 'center', padding: '50px' }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p>Loading dashboard data...</p>
                </div>
              ) : (
                <div className="show-order-area dashboard">
                  <div>
                    <h2>
                      <span>
                        <i className="fa fa-th"></i> Statistics
                      </span>
                    </h2>
                  </div>
                  <div className="col-12 col-lg-12 col-sm-12">
                    <div className="row">
                      <div className="col-xl-2 col-sm-4">
                        <div className="info-card sales-card leaf-green">
                          <div className="card-body">
                            <Link to="/dashboard/SalesOrder">
                              <p> Sales </p>
                              <b id="sales_order_grand_total">
                                {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.sales_grand_total
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                              <b id="sales_order_item_tax">
                                {company_tax_type} {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.sales_item_tax
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-2 col-sm-4">
                        <div className="info-card sales-card leaf-green">
                          <div className="card-body">
                            <Link to="#">
                              <p> Accept  </p>
                              <b id="sales_order_grand_total">
                                {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.accept_order_total
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                              <b id="sales_order_item_tax">
                                {company_tax_type} {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.accept_order_tax
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-2 col-sm-4">
                        <div className="info-card sales-card leaf-green">
                          <div className="card-body">
                            <Link to="/dashboard/InprogressInvoice">
                              <p> Inprogress  </p>
                              <b id="inprogress_grand_total">
                                {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.inprogress_invoice_grand_total

                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                              <b id="inprogress_item_tax">
                                {company_tax_type}  {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.inprogress_invoice_tax
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-2 col-sm-4">
                        <div className="info-card sales-card tomatored">
                          <div className="card-body">
                            <Link to="/dashboard/DeliveredInvoice">
                              <p> Delivered  </p>
                              <b id="delivered_invoice_grand_total">
                                {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.delivered_invoice_grand_total
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                              <b id="delivered_invoice_item_tax">
                                {company_tax_type} {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.delivered_invoice_item_tax
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-2 col-sm-4">
                        <div className="info-card sales-card tomatored">
                          <div className="card-body">
                            <Link to="/reports/missing_order">
                              <p> Cross Off </p>
                              <b id="cross_off_grand_total">
                                {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.crossOff_grand_total
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                              <b id="cross_off_item_tax">
                                {company_tax_type}  {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.crossOff_item_tax
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-2 col-sm-4">
                        <div className="info-card sales-card tomatored">
                          <div className="card-body">
                            <Link to="#">
                              <p> Undeliver /Reject </p>
                              <b id="undelivered_order_grand_total">
                                {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.undelivered_grand_total
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                              <b id="undelivered_order_item_tax">
                                {company_tax_type} {currencySymbol} {statisticsData
                                  ? parseFloat(
                                    statisticsData.undelivered_item_tax
                                  ).toFixed(2)
                                  : "0.00"}
                              </b>{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h2>
                    <span>
                      <i className="fa fa-calendar"></i> DAILY MIS
                    </span>
                  </h2>

                  <div className="col-12 col-lg-12 col-sm-12">
                    <div className="row">
                      <div className="col-12 col-sm-4 col-lg-2">
                        <Link
                          to="/dashboard/NewSales"
                          className="bred white quick-button"
                        >
                          <p className="yellow">
                            New <br /> Sales
                          </p>
                          <b>{statisticsData ? statisticsData.new_sales : 0}</b>
                        </Link>
                      </div>
                      <div className="col-12 col-sm-4 col-lg-2">
                        <Link
                          to="/dashboard/OrderAccepted"
                          className="blightOrange white quick-button"
                        >
                          <p className="yellow">
                            Order <br /> Accepted
                          </p>
                          <b>{statisticsData ? statisticsData.sale_accept : 0}</b>
                        </Link>
                      </div>
                      <div className="col-12 col-sm-4 col-lg-2">
                        <Link
                          to="/dashboard/picklistGenerated"
                          className="bgrey white quick-button"
                        >
                          <p className="yellow">
                            Picklist <br /> Generated
                          </p>
                          <b>{statisticsData ? statisticsData.picklistgenerated : 0}</b>
                        </Link>
                      </div>
                      <div className="col-12 col-sm-4 col-lg-2">
                        <Link
                          to="/dashboard/PickingConfirm"
                          className="blightBlue white quick-button"
                        >
                          <p className="yellow">
                            Picking <br /> Confirmed
                          </p>
                          <b>
                            {statisticsData
                              ? `${statisticsData.picking_confirmed} (${statisticsData.picking_confirmed_inv})`
                              : 0}
                          </b>
                        </Link>
                      </div>
                      <div className="col-12 col-sm-4 col-lg-2">
                        <Link to="/dashboard/ManifestGenerated" className="bpink white quick-button">
                          <p className="yellow">
                            Manifest <br /> Generated
                          </p>
                          <b>
                            {statisticsData
                              ? `${statisticsData.manifestgenerated} (${statisticsData.manifest_order})`
                              : 0}
                          </b>
                        </Link>
                      </div>
                      <div className="col-12 col-sm-4 col-lg-2">
                        <Link to="/dashboard/DeliveryConfirmed" className="bdarkGreen white quick-button">
                          <p className="yellow">
                            Delivery <br /> Confirmed
                          </p>
                          <b>
                            {statisticsData
                              ? statisticsData.delivery_confirmed
                              : 0}
                          </b>
                        </Link>
                      </div>
                      <div className="col-12 col-sm-4 col-lg-2">
                        <Link
                          to="/dashboard/TopSales"
                          className="bred white quick-button"
                        >
                          <p className="yellow">
                            Top <br /> Sales
                          </p>
                          <b id="top_sales">
                            {statisticsData
                              ? `${statisticsData.top_sales
                              } ${currencySymbol} ${statisticsData.top_sales_amount.toFixed(2)}`
                              : 0.0}
                          </b>
                        </Link>
                      </div>
                      <div className="col-12 col-sm-4 col-lg-2">
                        <Link
                          to="/dashboard/MaxValueOrder"
                          className="bred white quick-button"
                        >
                          <p className="yellow">
                            Max Value <br /> Order
                          </p>
                          <b id="top_customer_sales">
                            {statisticsData
                              ? `${statisticsData.top_customer_sales
                              }  ${currencySymbol} ${statisticsData.top_customer_amount.toFixed(
                                2
                              )}`
                              : 0.0}
                          </b>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;